// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const count_WIKI_AI_REVIEW_SUMMARY_SUMMARIZED_FROM = ["Zhrnut\u00e9 pomocou AI z %(count)s recenzie", "Zhrnut\u00e9 pomocou AI z %(count)s recenzi\u00ed", "Zhrnut\u00e9 pomocou AI z %(count)s recenzi\u00ed"];
export const WIKI_AI_REVIEW_SUMMARY_BADGE = "Zhrnutie hodnoten\u00ed";
export const WIKI_AI_REVIEW_SUMMARY_DISCLAIMER = "Automatick\u00fd s\u00fahrn hodnoten\u00ed generovan\u00fd umelou inteligenciou";
export const WIKI_AI_REVIEW_SUMMARY_DRAFT = "Nezverejnen\u00e9 \u00b7 len pre adminov";
export const WIKI_AI_REVIEW_SUMMARY_HIDE = "Skry\u0165";
export const WIKI_AI_REVIEW_SUMMARY_NEGATIVES = "Naj\u010dastej\u0161ie m\u00ednusy";
export const WIKI_AI_REVIEW_SUMMARY_POSITIVES = "Naj\u010dastej\u0161ie plusy";
export const WIKI_AI_REVIEW_SUMMARY_SHOW = "Zobrazi\u0165 cel\u00e9 zhrnutie";
